import { Grid, GridItem } from '@chakra-ui/react';
import React from 'react';
import { commonStyle } from '../../../../common/styles';
import {
  DialogTrainInfoType,
  DialogTrainsInfoType
} from '../../../../context/TransitsContextProvider';
import { TrainSVG } from './TrainSVG';

type Props = {
  placeInfo: DialogTrainsInfoType;
  trainInfo: DialogTrainInfoType;
  setTrainInfo: React.Dispatch<React.SetStateAction<DialogTrainInfoType>>;
};

export const Trains: React.FC<Props> = (props) => {
  const { placeInfo, trainInfo, setTrainInfo } = props;

  return (
    <Grid
      w='100%'
      h='100%'
      gridTemplateColumns='repeat(4, 1fr)'
      gridTemplateRows='100%'
    >
      {placeInfo.trains.map((train, index) => (
        <GridItem
          key={`train_${train.train_no}`}
          w='100%'
          h='100%'
          padding='5px'
          cursor='pointer'
          sx={{
            ...commonStyle.center
          }}
        >
          <TrainSVG
            trainNo={train.train_no}
            course={train.course}
            logo={train.low_floor_flag}
            selected={train.train_no === trainInfo.train_no}
            onClick={() => {
              setTrainInfo(placeInfo.trains[index]);
            }}
          ></TrainSVG>
        </GridItem>
      ))}
    </Grid>
  );
};
